import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {procedurePageUrl} from 'procedures/network/procedureUrls';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';

import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export interface ProcedureChipProps extends SharedSmartChipProps<SmartChipType.PROCEDURE> {
  flowchartVersionId?: string;
}

export default function ProcedureChip(props: ProcedureChipProps): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: procedure,
    handleClickLink,
    isInaccessible,
    itemUrl: procedureUrl,
  } = useSmartChipQuery<SmartChipType.PROCEDURE>({
    id,
    onClick,
    getUrlFn: (procedure) =>
      procedurePageUrl(procedure.id, {procedureFlowchartVersionId: props.flowchartVersionId}),
  });
  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={ModelTypeConstants.PROCEDURE}
      isInaccessible={isInaccessible}
      item={procedure}
      onClick={handleClickLink}
      url={procedureUrl}
      popoverContentOverride={null}
    />
  );
}
